import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { DynamicBarService } from 'src/app/_components/dynamic-bar/dynamic-bar.service';
import { RetroalimentacionReportService } from './retroalimentacion-report.service';

@Component({
  selector: 'app-retroalimentacion-report',
  standalone: false,
  templateUrl: './retroalimentacion-report.component.html',
  styleUrls: ['./retroalimentacion-report.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RetroalimentacionReportComponent implements OnInit {

  displayedColumns = [
    "profesor",
    "evento",
    "fecha",
    "materia",
    "curso",
    "porcentaje",
    "link",
  ];

  vm$ =combineLatest([
    this.retroalimentacionReporte.loading$,
    this.retroalimentacionReporte.evidenciasResult$,
    this.retroalimentacionReporte.prosearch$,
    this.retroalimentacionReporte.matsearch$,
    this.retroalimentacionReporte.pageSize$,
    this.retroalimentacionReporte.pageIndex$,
    this.retroalimentacionReporte.pageSizeOptions$,
    this.retroalimentacionReporte.length$,
  ]).pipe(
    map(
      ([
        loading,
        evidencias,
        prosearch,
        matsearch,
        pageSize,
        pageIndex,
        pageSizeOptions,
        length,
      ])=>{
        return{
          loading,
          evidencias,
          prosearch,
          matsearch,
          pageSize,
          pageIndex,
          pageSizeOptions,
          length,
        };
      }
    )
  );

  constructor
  (
    private retroalimentacionReporte: RetroalimentacionReportService,
    private dynamicBarService: DynamicBarService,
  ) { }

  ngOnInit(): void {
    this.dynamicBarService.setBarra('asistencia-reporte-evidencias-barra');
  }

  searchProfesor(event: any) {
    this.retroalimentacionReporte.searchProfesor(event.target.value);
  }

  resetSearch() {
    this.retroalimentacionReporte.searchProfesor("");
    this.retroalimentacionReporte.searchMateria("");
  }

  searchMateria(event: any) {
    this.retroalimentacionReporte.searchMateria(event.target.value);
  }

  setPage(event: PageEvent) {
    if (event?.pageSize) {
      this.retroalimentacionReporte.setPageSize(event.pageSize);
    }
    if (event?.pageIndex !== event?.previousPageIndex) {
      this.retroalimentacionReporte.setPageIndex(event.pageIndex);
    }
  }
}
